module.exports = __webpack_public_path__ + "img/abstract-shapes-11.87e88044.svg";